import { render, staticRenderFns } from "./codHubClosureReport.vue?vue&type=template&id=357265ea&"
import script from "./codHubClosureReport.vue?vue&type=script&lang=js&"
export * from "./codHubClosureReport.vue?vue&type=script&lang=js&"
import style0 from "./codHubClosureReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports